/**
 * Experience Engine bridge plugin (Sprint 6C).
 * Publishes Experience/intro lifecycle onto the Event Bus; no direct provider coupling.
 */
import { createPlugin } from "../createPlugin";
import { PlaybackPlatformEvent } from "../../Core/PlaybackPlatformEvents";

/**
 * @param {object} [options]
 * @param {function} [options.getStateService]
 */
export function createExperienceBridgePlugin(options) {
  options = options || {};

  return createPlugin({
    name: "experience-bridge",
    version: "1.0.0",
    onReady: function (ctx) {
      var svc =
        typeof options.getStateService === "function"
          ? options.getStateService()
          : null;
      if (svc && svc.registerPluginName) {
        svc.registerPluginName("experience-bridge");
      }
      var bus = ctx.eventBus || ctx.bus;
      var snap = svc && svc.getState ? svc.getState() : null;
      if (bus && typeof bus.publish === "function" && snap) {
        bus.publish(PlaybackPlatformEvent.PIPELINE_PHASE, {
          phase: snap.pipelinePhase,
          experience: snap.experience,
          sessionId: snap.sessionId,
        });
      }
    },
    onEvent: function (eventName, payload, ctx) {
      // Re-broadcast intro markers for Experience overlays / recommendations
      if (
        eventName === PlaybackPlatformEvent.INTRO_STARTED ||
        eventName === PlaybackPlatformEvent.INTRO_ENDED ||
        eventName === PlaybackPlatformEvent.INTRO_SKIPPED
      ) {
        var bus = ctx.eventBus || ctx.bus;
        if (bus && typeof bus.publish === "function") {
          bus.publish("EXPERIENCE_INTRO_EVENT", {
            event: eventName,
            payload: payload,
          });
        }
      }
      if (
        eventName === "PlaybackEnded" ||
        eventName === PlaybackPlatformEvent.ENDED
      ) {
        var b2 = ctx.eventBus || ctx.bus;
        if (b2 && typeof b2.publish === "function") {
          b2.publish(PlaybackPlatformEvent.RECOMMENDATION_REQUEST, {
            reason: "playback_ended",
            payload: payload,
          });
        }
      }
    },
  });
}

export default createExperienceBridgePlugin;
